import ct from "class-types.macro";
import React, { CSSProperties } from "react";
import { NewItemsCategory } from "./NewItemsPageResult";

interface Props {
  largestCategories: NewItemsCategory[];
}

const imageStyle: CSSProperties = {
  mixBlendMode: "darken",
  alignSelf: "center",
};

const headerStyle: CSSProperties = {
  textShadow: "none",
};

export default function NewItemsLargestCategories({
  largestCategories,
}: Props) {
  return (
    <div className={ct("flex", "flex-col", "-mx-3", "md:flex-row")}>
      {largestCategories.map((category: NewItemsCategory) => (
        <div
          className={ct(
            "bg-gray-50",
            "border-gray-200",
            "rounded",
            "border-solid",
            "border",
            "flex",
            "items-center",
            "flex-1",
            "mx-3",
            "mb-3",
            "px-3",
            "pt-5",
            "pb-6",
            "shadow-sm",
            "sm:pb-5",
            "md:flex-col",
            "md:justify-between",
          )}
          key={category.id}
        >
          <img
            src={category.image}
            alt={category.name}
            style={imageStyle}
            className={ct(
              "self-center",
              "mr-5",
              "max-w-xs",
              "w-3/12",
              "md:mr-0",
              "md:w-5/12",
            )}
            aria-hidden="true"
          />
          <div className={ct("w-11/12", "md:text-center")}>
            <p
              className={ct(
                "font-semibold",
                "text-xl",
                "leading-snug",
                "mb-0",
                "text-red-600",
              )}
            >
              {category.title}
            </p>
            <h2
              className={ct(
                "font-semibold",
                "text-xl",
                "leading-none",
                "mb-4",
                "md:text-2xl",
              )}
              style={headerStyle}
            >
              {category.name}
            </h2>
            <a
              href={category.filterUrl}
              className="btn btn-info py-1 sm:py-2"
              aria-label={`Shop All ${category.name}`}
            >
              Shop All
            </a>
          </div>
        </div>
      ))}
    </div>
  );
}
